









































import Vue from "vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  Ref,
} from "@vue/composition-api";

const remToPx = (rem: number): number => {
  const pxIn1Rem = Number.parseFloat(
    getComputedStyle(document.documentElement).fontSize as string
  );
  return pxIn1Rem * rem;
};

function emptyFn() {
  return () => {
    /*  */
  };
}

const debounce = (time: number) => (fn: (...args: any[]) => void) => {
  let taskId = 0;
  return (...args: any[]) => {
    clearTimeout(taskId);
    taskId = setTimeout(() => {
      fn(...args);
    }, time);
  };
};

export default Vue.extend({
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loading_text: {
      type: String,
      default: "",
    },
    renderAllUnder: {
      type: Number,
      default: 80,
    },
    itemWrapperClass: {
      type: String,
      default: "defaultItemWrapper",
    },
    itemHeightRem: {
      type: Number,
      default: 3.125,
    },
  },
  setup(props, { emit }) {
    const scrollMaster: Ref<HTMLElement | null> = ref(null);
    const getContainerWrapperEl = () => scrollMaster.value as HTMLElement;

    const containerHeight = ref("100%");
    const containerHeightNum = computed(() =>
      Number.parseFloat(containerHeight.value)
    );

    const itemHeight = ref(remToPx(props.itemHeightRem as number));
    const itemsInPort = ref(16);

    const items = computed(() =>
      (props.items as any[]).map((d, scrollId) => ({ ...d, scrollId }))
    );
    const totalPadding = computed(() => items.value.length * itemHeight.value);
    const paddingTop = ref(0);

    const firstIndex = ref(0);
    const displayItems = computed(() =>
      items.value.slice(firstIndex.value, firstIndex.value + 30)
    );

    const throttle_events_count_and_time = (
      onCount: number,
      time: number,
      fn: (ev: Event) => void
    ) => {
      let eventCount = 0;
      let timeoutId = 0;
      let batchId = 0;
      let lastEvent: Event;
      const timeout_batch_exec_fn = (id: number) => () => {
        if (batchId === id) {
          fn(lastEvent);
        }
      };

      return (ev: Event) => {
        lastEvent = ev;
        batchId++;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(timeout_batch_exec_fn(batchId), time);
        if (eventCount < onCount) {
          eventCount++;
        } else {
          eventCount = 0;
          fn(lastEvent);
          clearTimeout(timeoutId);
        }
      };
    };
    let lastScrollTop = 0;

    const bottomTrashHold = computed(() => itemHeight.value * 0.5);

    const onScroll = throttle_events_count_and_time(12, 100, (ev: Event) => {
      let { scrollTop } = ev.target as Element;
      if (scrollTop < 0) {
        scrollTop = 0;
      }
      if (Math.abs(lastScrollTop - scrollTop) < (itemHeight.value * 2) / 3) {
        return;
      }
      lastScrollTop = scrollTop;
      paddingTop.value = scrollTop;
      const paddingBottom = totalPadding.value - paddingTop.value;
      firstIndex.value = Math.round(scrollTop / itemHeight.value);
      if (
        paddingBottom - bottomTrashHold.value <= containerHeightNum.value &&
        !props.isLoading
      ) {
        emit("loadMore");
      }
    });

    //#resion scroll listener
    const removeScrollListener = emptyFn();
    const addScrollListener = () => {
      getContainerWrapperEl().addEventListener("scroll", onScroll);
      return () =>
        getContainerWrapperEl().removeEventListener("scroll", onScroll);
    };
    //#endregion

    const getContainerHeight = () =>
      Number.parseFloat(getComputedStyle(getContainerWrapperEl()).height);
    //#region resize
    let removeResizeListener = emptyFn();
    const onResizeHandler = debounce(200)(() => {
      const heightNum = getContainerHeight();
      itemHeight.value = remToPx(props.itemHeightRem as number);
      containerHeight.value = heightNum + "px";
      itemsInPort.value = Math.floor(heightNum / itemHeight.value);
    });
    const addResizeListener = () => {
      window.addEventListener("resize", onResizeHandler);
      return () => window.removeEventListener("resize", onResizeHandler);
    };

    //#endregion

    onMounted(() => {
      const heightNum = getContainerHeight();
      containerHeight.value = heightNum + "px";
      itemsInPort.value = Math.floor(heightNum / itemHeight.value);

      setTimeout(() => {
        containerHeight.value = getContainerHeight() + "px";
      }, 0);
      addScrollListener();
    });

    removeResizeListener = addResizeListener();

    onBeforeUnmount(() => {
      removeResizeListener();
      removeScrollListener();
    });

    // @public
    const rePosition = () => {
      setTimeout(() => {
        getContainerWrapperEl().scrollTop = paddingTop.value;
      }, 200);
    };

    return {
      scrollMaster,
      displayItems,
      totalPadding,
      paddingTop,
      containerHeight,
      rePosition,
    };
  },
});
